export default [
  {
    title: "Users",
    route: "users",
    icon: "FileIcon",
  },
];
